<template>
  <div>
    <div style="background-color: lightgrey">
      <van-collapse v-model="activeNames">
        <van-collapse-item name="1" title="查询条件">
          <van-field v-model="queryFormModel.title" :colon="true" label="标题" placeholder="请输入标题"/>
          <van-field v-model="queryFormModel.content" :colon="true" label="内容" placeholder="请输入内容"/>
          <div class="flex justify-center margin-tb-xs">
            <van-button size="large" type="info" @click="onLoad(true)">查询</van-button>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <van-list
        v-model="loading"
        :finished="listFinished"
        finished-text="没有更多了"
        @load="onLoad"
    >
      <van-cell v-for="(item,index) in list" :key="index">
        <template>
          <router-link class="title" :to="'/admin/notice/log-detail/'+ item.id">
            <div>{{item.title}}</div>
            <van-icon name="arrow" color="#333" />
          </router-link>
        </template>
      </van-cell>
    </van-list>
  </div>
</template>
<script>
import Vue from 'vue';
import {
  Button,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Collapse,
  CollapseItem,
  Dialog,
  DropdownItem,
  DropdownMenu,
  Field,
  Icon,
  ImagePreview,
  List,
  Picker,
  Popup,
  Switch,
  Tag,
  Toast
} from 'vant';
import {sysUpdateLogList} from "@/api/admin/notice";
import moment from "moment";

Vue.use(Button)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Field)
Vue.use(ImagePreview)
Vue.use(List)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(Switch)
Vue.use(Icon)
Vue.use(Tag);
Vue.use(Dialog)
export default {
  name: "log-list",
  props: {},
  components: {},
  computed: {},
  data() {
    return {
      queryFormModel: {
        title: null,
        content: null,
      },
      clerkMap: new Map(),
      list: [],
      loading: false,
      listFinished: false,
      pageNo: 1,
      pageSize: 10,
      activeNames: [1]
    }
  },
  methods: {
    formatTime(e) {
      return moment(e).format('YYYY-MM-DD HH:mm')
    },
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },
    onLoad(resetPage) {
      // 重置为首页
      if (resetPage) {
        this.pageNo = 1
      }
      // 清空数据
      if (this.pageNo == 1) {
        this.list = [];
      }
      this.loading = true
      sysUpdateLogList(this.queryFormModel.title, this.queryFormModel.content, this.pageNo, this.pageSize).then(res => {
        this.loading = false;
        const data = res.data;
        if (data.code === 0) {
          this.list = this.list.concat(data.list)
          if (data.hasNextPage) {
            this.listFinished = false
          } else {
            this.listFinished = true
          }
        } else {
          this.listFinished = true
          Dialog.alert({
            title: '加载' + this.$store.state.label.clerkLabel + '失败',
            message: data.msg
          })
        }
        this.pageNo++
      })
    }
  },
  mounted() {},
  updated() {
    // 统一替换标签
    this.$replaceLabel(document.body, this.$store.state.label, true)
  }
}
</script>
<style lang="less" scoped>
.label {
  color: #999;
  margin-right: 5px;
}
.qrbox {
  display: table;
  margin: 10px auto;
}

.btn-play-audio {
  img {
    height: 20px;
  }
}
.title{
  display: flex;
  align-items: center;
  color: #333;
  div{
    flex: 1;
  }

}
</style>
